export let calendarMonth_July = "nmKM8";
export default {calendarMonth_July};